import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TransportFilters, TransportStatus, transportStatuses } from '@icc/b2b/shared';

@Component({
    selector: 'icc-transport-filters',
    templateUrl: './transport-filters.component.html',
    styleUrls: ['./transport-filters.component.scss'],
})
export class TransportFiltersComponent {
    documentNumber = '';
    status: TransportStatus | null= null;
    contractorCompanyName = '';

    transportStatuses = transportStatuses;

    protected _filters: TransportFilters;

    @Input()
    get filters(): TransportFilters {
        return this._filters;
    }
    set filters(filters: TransportFilters) {
        this.setFilters(filters);
    }
    @Input() documentStatuses: TransportStatus[];
    @Input() hasContractorFilter = false;

    @Output() filtersEmitter = new EventEmitter<{
        filters: TransportFilters;
        reset: boolean;
    }>();

    setFilters(filters: TransportFilters) {
        if (filters) {
            this._filters = filters;
            this.documentNumber = filters.documentNumber;
            this.status = filters.status;
            this.contractorCompanyName = filters.contractorCompanyName;

        } else {
            this.resetFilters(false);
        }
    }

    handleStatus(value) {
        if (!value || value === 'null') {
            value = null;
        }
        this.status = value;
    }

    emitFilters(reset = false) {
        this.filtersEmitter.emit({
            filters: {
                documentNumber: this.documentNumber,
                status: this.status,
                contractorCompanyName: this.contractorCompanyName,
            },
            reset,
        });
    }

    resetFilters(emit = true) {
        this.documentNumber = '';
        this.contractorCompanyName = '';
        this.status = null;
        if(emit)this.emitFilters(true);
    }
}
